import React from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import classes from './box-details-block.scss';
export default function BoxDetailsBlock({
  pricePerBox,
  assemblyFee,
  productionTimeDays,
  previewImage,
  name,
  description,
  additionalProductionTimeText,
  selectedBoxDataType
}) {
  const isBrownBox = selectedBoxDataType === SPECIAL_PRODUCT_TYPES.BROWN_BOX;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.boxInfo]: !isBrownBox,
      [classes.brownBoxInfo]: isBrownBox
    })
  }, /*#__PURE__*/React.createElement(Image, {
    src: previewImage,
    alt: name,
    wrapperClassName: classes.imageWrapper,
    className: classes.image
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.boxDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.boxDetailsTitle]: !isBrownBox,
      [classes.brownBoxDetailsTitle]: isBrownBox
    })
  }, name, " (", description, ")"), /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.boxDetailsDescription]: !isBrownBox,
      [classes.brownBoxDetailsDescription]: isBrownBox
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.leftBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text,
    "data-text": "ItemPrice"
  }, "Price Per Box: $", pricePerBox / 100), /*#__PURE__*/React.createElement("div", {
    className: classes.text,
    "data-text": "AssemblyFee"
  }, "Kitting Fee: $", assemblyFee / 100)), /*#__PURE__*/React.createElement("div", {
    className: classes.text,
    "data-text": "ProductionTime"
  }, "Production Time: ", productionTimeDays, " Business Days", additionalProductionTimeText && /*#__PURE__*/React.createElement("div", {
    className: classes.additionalProductionTimeText
  }, "(", additionalProductionTimeText, ")")))));
}